module.exports = __webpack_public_path__ + "static/media/file-mp4.44ad4d81.svg";